import * as React from 'react';
import { useTheme } from '../Theme/Theme';
import { style } from './style';
export const Carousel = (props) => {
    const [sliderIndex, setSlideIndex] = React.useState(Number(props.current) || 0);
    React.useEffect(() => {
        let cTimeout = null;
        if (props.autoScroll) {
            cTimeout = setTimeout(() => {
                setSlideIndex((sliderIndex + 1) % props.children.length);
            }, 3000);
        }
        return () => {
            window.clearTimeout(cTimeout);
        };
    }, [sliderIndex, props.children.length]);
    React.useEffect(() => {
        setSlideIndex(props.current);
    }, [props.current]);
    const theme = useTheme();
    const css = style(theme);
    return (React.createElement("div", { className: css.container, style: { width: props.width } },
        React.createElement("div", { className: css.carousel, style: {
                width: `${100 * props.children.length}%`,
                transform: `translate3d(-${(100 / props.children.length) * sliderIndex}%, 0, 0)`,
            } }, props.children.map((v, index) => (React.createElement("div", { className: css.item, key: index, style: { width: getItemWidth(props.children.length) } }, v)))),
        !props.hideDots && (React.createElement("div", { className: css.dotsContainer }, props.children.map((v, index) => (React.createElement("li", { key: index, className: css.dots, onClick: () => setSlideIndex(index), style: {
                background: index === sliderIndex && 'white',
            } })))))));
};
Carousel.defaultProps = {
    current: 0,
};
const getItemWidth = (len) => {
    return 100 / len + '%';
};
//# sourceMappingURL=Carousel.js.map